import { initializeApp } from 'firebase/app';
import { getAuth } from "firebase/auth";
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
    apiKey: "AIzaSyAdR-TSzwKlFJMzlTewOz4Df3H0zNbFqZk",
    authDomain: "bode-project-a4bc4.firebaseapp.com",
    databaseURL: "https://bode-project-a4bc4-default-rtdb.firebaseio.com",
    projectId: "bode-project-a4bc4",
    storageBucket: "bode-project-a4bc4.appspot.com",
    messagingSenderId: "824340694515",
    appId: "1:824340694515:web:5a229a2e542a22f105be86",
    measurementId: "G-RKM62YT8VX"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const database = getDatabase(app);
